import { z } from "zod";

import { ReferralStatusRequestDocumentType } from "@/src/models/constants/document-types";
import { Specialty } from "@/src/models/constants/specialty";
import { DatabaseDefaults } from "@/src/models/database-defaults";
import { DocumentDateSchema } from "@/src/models/documents/document-dates";
import { locationSchema } from "@/src/models/location";
import { Patient, patientSchema } from "@/src/models/patient";
import { practitionerSchema } from "@/src/models/practitioner";

export const referralStatusRequestTypeDisplay: Record<ReferralStatusRequestDocumentType, string> = {
  [ReferralStatusRequestDocumentType.REFERRAL_STATUS_REQUEST]: "Referral Status",
};

export const referralStatusRequestTypeSchema = z.nativeEnum(ReferralStatusRequestDocumentType);

export const referralStatusRequestSchema = z.object({
  type: referralStatusRequestTypeSchema,
  specialty: z.nativeEnum(Specialty).nullable(),
  patient: patientSchema,
  location: z.string().nullable(),
  receivingLocation: locationSchema.nullable(),
  provider: practitionerSchema.nullable(),
  receivingProvider: practitionerSchema.nullable(),
  ...DocumentDateSchema.shape,
});

export type ReferralStatusRequest = Omit<z.infer<typeof referralStatusRequestSchema>, "patient"> & {
  patient: Patient | null;
} & DatabaseDefaults;

export const referralStatusRequestShape: ReferralStatusRequest = {
  id: "",
  type: ReferralStatusRequestDocumentType.REFERRAL_STATUS_REQUEST,
  patient: null,
  location: null,
  receivingLocation: null,
  provider: null,
  receivingProvider: null,
  createdAt: "",
  updatedAt: "",
  deletedAt: null,
  groupId: "",
  specialty: null,
  dateOfDocument: null,
  dateReceived: null,
  dateSigned: null,
  dateOfEvent: null,
};
